import { InMemoryCache } from 'apollo-cache-inmemory';

export class BroadcastConfigurableInMemoryCache extends InMemoryCache {
	private shouldBroadcast: boolean = true;

	protected override broadcastWatches(): void {
		if (this.shouldBroadcast) {
			super.broadcastWatches();
		}
	}

	public setShouldBroadcast(shouldBroadcast: boolean) {
		this.shouldBroadcast = shouldBroadcast;
	}
}
